import api from './api';

const labelService = {
  generateLabels: async (cutPlanId, positionIds, planCode, projectId) => {
    try {
      const response = await api.post('/cutting-labels/generate', {
        cutPlanId,
        positionIds,
        planCode,
        projectId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar etiquetas:', error);
      throw error;
    }
  },

  getLabelsByPlan: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-labels/plan/${cutPlanId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar etiquetas:', error);
      throw error;
    }
  },

  getLabelById: async (id) => {
    try {
      const response = await api.get(`/cutting-labels/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar etiqueta:', error);
      throw error;
    }
  },

  getLabelStats: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-labels/plan/${cutPlanId}/stats`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      throw error;
    }
  },

  printLabel: async (id) => {
    try {
      const response = await api.put(`/cutting-labels/${id}/print`);
      return response.data;
    } catch (error) {
      console.error('Erro ao imprimir etiqueta:', error);
      throw error;
    }
  },

  reprintLabel: async (id) => {
    try {
      const response = await api.put(`/cutting-labels/${id}/print`);
      return response.data;
    } catch (error) {
      console.error('Erro ao reimprimir etiqueta:', error);
      throw error;
    }
  },

  invalidateLabel: async (id, reason) => {
    try {
      const response = await api.put(`/cutting-labels/${id}/invalidate`, { reason });
      return response.data;
    } catch (error) {
      console.error('Erro ao invalidar etiqueta:', error);
      throw error;
    }
  }
};

export default labelService;
